function OrderOptionsSummary() {
    const [selectedShape, setSelectedShape] = React.useState(null);
    const [selectedBlade, setSelectedBlade] = React.useState(null);
    const [selectedHandle, setSelectedHandle] = React.useState(null);
    const [bladeData, setBladeData] = React.useState(null);
    const [handleData, setHandleData] = React.useState(null);
    
    const shapeInfo = {
        santoku: { 
            name: 'Santoku', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-santoku.png?v=1769401464'
        },
        nakiri: { 
            name: 'Nakiri', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-nakiri.png?v=1769401464'
        },
        gyuto: { 
            name: 'Gyuto', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-gyuto.png?v=1769401464'
        },
        bunka: { 
            name: 'Bunka', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-bunka.png?v=1769401464'
        },
        kobunka: { 
            name: 'Kobunka', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kobunka.png?v=1769401464'
        },
        petty: { 
            name: 'Petty', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-petty.png?v=1769401464'
        },
        'kiritsuke-petty': { 
            name: 'Kiritsuke Petty', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke-petty.png?v=1769401464'
        },
        kiritsuke: { 
            name: 'Kiritsuke', 
            image: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke.png?v=1769401464'
        }
    };
    
    React.useEffect(() => {
        const checkState = setInterval(() => {
            if (typeof window.KnifeCustomizationState === 'undefined') return;
            
            if (window.KnifeCustomizationState.selectedShape !== selectedShape) {
                setSelectedShape(window.KnifeCustomizationState.selectedShape);
            }
            if (window.KnifeCustomizationState.selectedBlade !== selectedBlade) {
                setSelectedBlade(window.KnifeCustomizationState.selectedBlade);
            }
            if (window.KnifeCustomizationState.selectedHandle !== selectedHandle) {
                setSelectedHandle(window.KnifeCustomizationState.selectedHandle);
            }
            if (window.KnifeCustomizationState.selectedBladeData !== bladeData) {
                setBladeData(window.KnifeCustomizationState.selectedBladeData);
            }
            if (window.KnifeCustomizationState.selectedHandleData !== handleData) {
                setHandleData(window.KnifeCustomizationState.selectedHandleData);
            }
        }, 100);
        
        return () => clearInterval(checkState);
    }, [selectedShape, selectedBlade, selectedHandle, bladeData, handleData]);
    
    // Get shape display info
    const currentShape = selectedShape ? shapeInfo[selectedShape] : null;
    
    // Get blade thumbnail from real product data
    const getBladeImage = () => {
        if (!bladeData) return '';
        if (bladeData.metafields && bladeData.metafields['custom.customization_thumbnail']) {
            return bladeData.metafields['custom.customization_thumbnail'];
        }
        return bladeData.image || '';
    };
    
    // Get handle thumbnail from real product data
    const getHandleImage = () => {
        if (!handleData) return '';
        if (handleData.metafields && handleData.metafields['custom.customization_thumbnail']) {
            return handleData.metafields['custom.customization_thumbnail'];
        }
        return handleData.image || '';
    };
    
    const bladeImage = getBladeImage();
    const bladeName = bladeData ? bladeData.name : null;
    
    const handleImage = getHandleImage();
    const handleName = handleData ? handleData.name : null;
    
    return React.createElement('div', { className: 'options-summary-grid' },
        // Shape card
        React.createElement('div', null,
            React.createElement('div', { className: 'summary-option-card' },
                React.createElement('div', { className: 'summary-option-label' }, 'Knife Shape'),
                React.createElement('div', { className: 'summary-option-placeholder' },
                    currentShape && currentShape.image ? React.createElement('img', {
                        src: currentShape.image,
                        alt: currentShape.name
                    }) : '\u00A0'
                ),
                currentShape && React.createElement('div', { className: 'summary-option-name' }, currentShape.name)
            )
        ),
        // Blade card
        React.createElement('div', null,
            React.createElement('div', { className: 'summary-option-card' },
                React.createElement('div', { className: 'summary-option-label' }, 'Blade Type'),
                React.createElement('div', { className: 'summary-option-placeholder' },
                    bladeImage ? React.createElement('img', {
                        src: bladeImage,
                        alt: bladeName || 'Blade'
                    }) : '\u00A0'
                ),
                bladeName && React.createElement('div', { className: 'summary-option-name' }, bladeName)
            )
        ),
        // Handle card
        React.createElement('div', null,
            React.createElement('div', { className: 'summary-option-card' },
                React.createElement('div', { className: 'summary-option-label' }, 'Handle Type'),
                React.createElement('div', { className: 'summary-option-placeholder' },
                    handleImage ? React.createElement('img', {
                        src: handleImage,
                        alt: handleName || 'Handle'
                    }) : '\u00A0'
                ),
                handleName && React.createElement('div', { className: 'summary-option-name' }, handleName)
            )
        )
    );
}

window.OrderOptionsSummary = OrderOptionsSummary;